__turbopack_context__.v({
  "backgroundImage": "GradientTextSections-module__Yh_oSG__backgroundImage",
  "backgroundImageWrapper": "GradientTextSections-module__Yh_oSG__backgroundImageWrapper",
  "contentWrapper": "GradientTextSections-module__Yh_oSG__contentWrapper",
  "desktopImage": "GradientTextSections-module__Yh_oSG__desktopImage" + " " + "GradientTextSections-module__Yh_oSG__backgroundImage",
  "mobileImage": "GradientTextSections-module__Yh_oSG__mobileImage" + " " + "GradientTextSections-module__Yh_oSG__backgroundImage",
  "paragraph": "GradientTextSections-module__Yh_oSG__paragraph" + " " + __turbopack_context__.i(527070)["body1"],
  "section": "GradientTextSections-module__Yh_oSG__section",
  "textContent": "GradientTextSections-module__Yh_oSG__textContent",
  "word": "GradientTextSections-module__Yh_oSG__word",
});
